import styled from "@emotion/styled/macro";
import { shadows } from "../../../../common/styles/theme.styles";

export const VaultMainTableWrapper = styled.div`
    display: flex;
    padding: 0px 16px 16px 16px;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    border-radius: 16px;
    background: #FFF;

    box-shadow: ${shadows.cardShadow};
`;

export const VaultMainTableHeader = styled.div`
    display: flex;
    padding: ${({ isEmptyState }) => isEmptyState ? '16px 8px 0px 8px' : '16px 8px 32px 8px'};
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 24px;
    align-self: stretch;
`;

export const VaultMainTableHeaderTitle = styled.div`
    color: var(--Dark-Gray-1, #1A1B1D);
    font-size: 14px;
    font-style: normal;
    font-weight: 450;
    line-height: 130%; /* 18.2px */
`;